/**
 * Video Background
 */
function setup_video(e){
    var config = [];
    if($('#bgvid').length) config.push({el:"#bgvid", srcs:"#bgvid-srcs"});
    var attr_key = e==="desktop" ? "desktop-poster" : "mobile-poster"


    for(var i=0; i<config.length; i++){
        var vid_id = config[i].el;
        var video = $(vid_id);
        if(video.length){  
            var poster = video.attr(attr_key);
            video.attr("poster",poster);
			
            if($(config[i].srcs).length>0) {
				
                for(var o=JSON.parse($(config[i].srcs).text())[e],d=0;d<o.length;d++){
                    video.append('<source content="default-src *; style-src \'self\' http://* \'unsafe-inline\'; script-src \'self\' http://* \'unsafe-inline\' \'unsafe-eval\'" src="'+o[d].src+'" type="'+o[d].type+'">');
                }
            }    
        }
    }    
}

$(window).on("load", function() {
	/*
	650 < $(window).width() ?
		setup_video("desktop") :
		setup_video("mobile");
		*/
	if($('.hero-banner').length)$('.hero-banner').addClass('loaded')
});

function checkScroll(){
	var scrollTop = $(window).scrollTop();
	var offset = $(window).height();
	offset = offset * .5;
    $('[animate-on-scroll]').each(function(){
		var top = $(this).offset().top;
		var height = $(this).height();
		var bottom = top + height;
		var min = top - offset;
		if ( scrollTop > min){
			$(this).addClass('animated');
		}
	});
}

$(document).ready( function() {
	$( '.swipebox' ).swipebox();
    checkScroll();
	$(window).scroll(function() {
	    if ($(document).scrollTop() > 100) {
	        $('header.banner').addClass('scrolled');
	    }
	    else {
	        $('header.banner').removeClass('scrolled');
	    }
	    checkScroll();
		
	});

	// mobile menu nav handling
	$('.menu-toggle').on('click', function(){
		$(this).toggleClass('closer');
		$('body').toggleClass('menu-open');
		$('.nav-primary').toggleClass('active');
	});

	// sticky footer
	var minH = $(window).height() - ( $('header.banner').height() + $('footer').outerHeight());
	$('.wrap').css({minHeight:minH});

	// // banner slider
	// if( $('.banner-slider') ) {
	// 	$('.banner-slider').slick({
	// 		arrows: false,
	// 		dots: false,
	// 		autoplay: true,
	// 		autoplaySpeed: 5000
	// 	});
	// }
	
	//init Swipe
	// $( '.swipebox' ).swipebox({
	// 	hideBarsDelay:0,
	// });

	//expander handling
	$('.expander-title').on("click", function() {
		$(this).toggleClass('open');
		$(this).siblings('.expander-content').slideToggle();
	})
	
	
var offset = 20;
	// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);

      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top-offset
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});
/*

GOOGLE MAPS
var apiKey = '';
var lat = 1;
var lng = 1; 
$(document).ready(function(){
	if ($('#map').length){
	 	// Asynchronously Load the map API 
    var script = document.createElement('script');
    script.src = "//maps.googleapis.com/maps/api/js?callback=initialize&key="+apiKey;
    document.body.appendChild(script);	
	}
});
		
function initialize() {
	var location = {lat: lat, lng:lng}
	var map;
	var mapOptions = {
		zoom:15,
		center: location,
		scrollwheel: false
	};
	
	map = new google.maps.Map(document.getElementById("map"), mapOptions);       
	var marker = new google.maps.Marker({
		position: location,
		map: map,
	});                

}

*/